/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useCallback, useState } from 'react'
import {
  Typography,
  Tooltip,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  ListItemIcon,
  IconButton,
} from '@material-ui/core'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { ReactComponent as SputnikIcon } from 'assets/Sputnik.svg'
import { ReactComponent as ISee } from 'assets/ISee.svg'
import {
  Archive14,
  Archive3,
  Archive30,
  Archive5,
  Archive7,
  IconColors,
  StrangeCamera,
} from 'sputnik-icons' // fix me
import { Power, PowerOff, Archive, FileCopy } from '@material-ui/icons'

import { useTranslation } from 'react-i18next'
import { DeviceModel, formatDeviceId, Input } from 'sputnik-ui'
// import cam from 'assets/cam.png'
// import sputnik from 'assets/sputnik.png'
import { ReactComponent as FaceRec } from 'features/services/face_rec.svg'
import useHover from 'hooks/useHover'
import { useDispatch, useSelector } from 'react-redux'
import { betaTestInProduction, copyToClipboard } from 'utils/helpers'
import { showInfoMessage } from 'store/ui/actions'
import { layerGroup } from 'leaflet'
import i18next from 'i18next'
import { isThirdParty } from 'utils/thirdPartyIntercomKinds'
import ThirdPartyEditIcon from 'components/molecules/ThirdPartyEditIcon'
import { ReactComponent as EditOutline } from '../../../assets/EditOutline.svg'

const Tag = styled.span`
  background: ${(p) => {
    switch (p.color) {
      case 'error':
        return p.theme.palette.error[50]

      default:
        return p.theme.palette.primary[500]
    }
  }};
  color: ${(p) => p.theme.palette[p.color].contrastText};
  padding: 0.125rem 0.325rem;
  border-radius: 8px;
  display: inline-flex;
`

const OnlineIcon = styled(Power)`
  color: ${(p) => p.theme.palette.success[500]};
  font-size: 0.825rem;
  margin-left: 0.325rem;
`
const OfflineIcon = styled(PowerOff)`
  color: ${(p) => p.theme.palette.error[500]};
  font-size: 0.825rem;
  margin-left: 0.325rem;
`

const styles = {
  icon: { fontSize: '0.625rem', marginRight: '.325rem', width: 16, height: 16 },
  secondaryRow: { display: 'flex', alignItems: 'center' },
  // с третьей линией (details) вторичный текст — колонка из двух строк
  secondaryColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 4,
  },
  secondaryLine: {
    display: 'inline-flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
}

const serviceIcons = {
  archive_3: <Archive3 color={IconColors.blue} style={styles.icon} />,
  archive_5: <Archive5 color={IconColors.blue} style={styles.icon} />,
  archive_7: <Archive7 color={IconColors.blue} style={styles.icon} />,
  archive_14: <Archive14 color={IconColors.blue} style={styles.icon} />,
  archive_30: <Archive30 color={IconColors.blue} style={styles.icon} />,
  face_rec: <FaceRec style={styles.icon} />,
}

export default function DeviceSearchSuggestion({
  firstInstalled,
  secondaryAction,
  to,
  type,
  withAddress = true,
  installed,
  uuid,
  address_type,
  address_uuid,
  serial_number,
  short_address,
  is_online,
  services,
  handleOpenModal,
  handleOpenIntercomModal,
  handleOpenServiceNoteModal,
  notice,
  alias,
  onOpen,
  // Третья линия строки (новая главная, business_apps#1486 §5.8); без неё
  // строка рисуется как раньше.
  details,
  // Явное переопределение кликабельности: по умолчанию неустановленное
  // устройство недоступно, новая главная ведёт такой домофон в карточку.
  disabled,
  // is_online = null — «нет данных» (контракт ГИС 29.09): новая главная не
  // рисует иконку статуса; старый список показывает такие как «не в сети».
  hideUnknownOnline = false,
  ...props
}) {
  const { t } = useTranslation(['devices', 'info'])
  const { hovered, bind } = useHover()
  const dispatch = useDispatch()
  const companyUuid = useSelector(({ auth }) => auth.user?.company?.uuid)

  const serviceText = {
    archive_3: i18next.t('devices:helper_text.archive_day', { days: 3 }),
    archive_5: i18next.t('devices:helper_text.archive_day', { days: 5 }),
    archive_7: i18next.t('devices:helper_text.archive_day', { days: 7 }),
    face_rec: i18next.t('devices:helper_text.face_rec'),
  }

  const thirdParty = isThirdParty(serial_number, type, props?.model)

  // Строка — Link с целью метрики: клик по карандашу не должен до неё дойти.
  // У сторонних устройств заметка правится в их модалках вместе с подключением.
  const handleEditNote = useCallback(
    (e) => {
      e.preventDefault()
      e.stopPropagation()
      if (thirdParty && type === 'camera') {
        handleOpenModal({ uuid })
      } else if (thirdParty) {
        handleOpenIntercomModal({ uuid })
      } else {
        handleOpenServiceNoteModal({ uuid, type, alias })
      }
    },
    [
      thirdParty,
      type,
      uuid,
      alias,
      handleOpenModal,
      handleOpenIntercomModal,
      handleOpenServiceNoteModal,
    ]
  )

  const formAddressUrl = () => {
    if (address_type === 'gate') {
      return `/gate/`
    }
    if (address_type === 'house') {
      return '/h/'
    }
    return '/e/'
  }

  const itemConfig = () => {
    if (isThirdParty(serial_number, type, props?.model) && !installed) {
      return {
        disabled: false,
        key: uuid,
        component: 'div',
        to: undefined,
        button: false,
      }
    }
    return {
      disabled: disabled === undefined ? !installed : disabled,
      key: uuid,
      component: Link,
      to: to || formAddressUrl() + address_uuid,
      button: true,
      // цель навигации уходит до перехода по Link (business_apps#1465)
      onClick: onOpen,
    }
  }

  const statusKnown = typeof is_online === 'boolean' || !hideUnknownOnline

  const secondaryContent = (
    <>
      {installed && statusKnown && (
        <>
          <Tooltip
            title={
              is_online
                ? t('devices:params.online')
                : t('devices:params.offline')
            }
          >
            {is_online ? (
              <OnlineIcon style={styles.icon} />
            ) : (
              <OfflineIcon style={styles.icon} />
            )}
          </Tooltip>
          {/* <Archive style={styles.icon} /> */}
        </>
      )}
      {services?.map((identifier) => {
        const Component = serviceIcons[identifier]
        const text = serviceText[identifier]
        return (
          <Tooltip title={text} key={identifier}>
            {Component}
          </Tooltip>
        )
      })}
      {withAddress && (short_address || t('devices:params.not_installed'))}
    </>
  )

  return (
    <ListItem {...itemConfig()} {...bind} {...props}>
      <ListItemIcon>
        {type === 'camera' ? (
          isThirdParty(serial_number, type, props?.model) ? (
            <StrangeCamera style={{ fill: 'black' }} />
          ) : (
            <ISee />
          )
        ) : (
          <SputnikIcon />
        )}
      </ListItemIcon>
      <ListItemText
        primary={
          // заметка, которой не хватает места, переносится на свою строку
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: '4px 8px',
            }}
          >
            <span>
              {type === 'camera'
                ? serial_number
                : formatDeviceId(serial_number)}
            </span>
            {address_type === 'gate' ? ` [ ${t('devices:units.gate')} ]` : null}
            <ThirdPartyEditIcon
              alias={alias}
              t={t}
              onClick={handleEditNote}
              // неустановленная своя строка disabled, и MUI снимает с неё
              // pointer-events — карандаш возвращает их себе
              iconButtomStyle={{ pointerEvents: 'auto' }}
            />
            <DeviceModel model={props?.model} />
            {/* место под иконку держим всегда: иначе при наведении она
                может переехать на новую строку и строка прыгнет */}
            <FileCopy
              style={{
                width: 14,
                height: 14,
                visibility: hovered ? 'visible' : 'hidden',
              }}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                copyToClipboard(serial_number)
                dispatch(
                  showInfoMessage(
                    t('info:copy.device', { number: serial_number })
                  )
                )
              }}
            />
          </div>
        }
        secondary={
          details ? (
            <>
              <span style={styles.secondaryLine}>{secondaryContent}</span>
              {details}
            </>
          ) : (
            secondaryContent
          )
        }
        secondaryTypographyProps={{
          style: details ? styles.secondaryColumn : styles.secondaryRow,
        }}
      />
      <ListItemSecondaryAction>
        {firstInstalled && firstInstalled.uuid === uuid && (
          <Tag color="primary" style={{ marginLeft: 'auto' }}>
            <Typography color="inherit">enter</Typography>
          </Tag>
        )}
        {secondaryAction}
        {/* {!installed && (
        <Tag color="error" style={{ marginLeft: 'auto' }}>
          <Typography color="textSecondary">не установлена</Typography>
        </Tag>
      )} */}
      </ListItemSecondaryAction>
    </ListItem>
  )
}

/*

  primary={
          <>
            {type === 'camera'
              ? serial_number
              : `${formatDeviceId(serial_number)} · ${short_serial}`}
          </>
        }
        secondary={
          <>
            {typeof is_online === 'boolean' && (
              <Tooltip title={is_online ? 'в сети' : 'не в сети'}>
                {is_online ? (
                  <OnlineIcon style={styles.icon} />
                ) : (
                  <OfflineIcon style={styles.icon} />
                )}
              </Tooltip>
            )}
            {services?.map((identifier) => {
              const Component = serviceIcons[identifier]

              return <Component style={styles.icon} />
            })}
            {`${address || 'Не установлена'}
            ${service_partner ? ` · Обслуживается «${service_partner}»` : ''}`}
          </>
        }
        secondaryTypographyProps={{
          style: {
            display: 'flex',
            alignItems: 'center',
          },
        }}

        */
